/** @file Emits mixDefaults as [from, to, seconds] triples (pair code-unit order, R12-01). */
import type { Doc, Pose2DJson } from '@pose2d/format/types';

/** undefined when the document has no mixDefaults; keys are "from>to" (validated by MIX_PAIR_RE), sorted by pair. */
export function compileMixDefaults(doc: Doc): Pose2DJson['mixDefaults'] {
  const pairs = doc.mixDefaults;
  if (pairs === undefined) return undefined;
  return Object.entries(pairs).sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0)).map(([pair, seconds]): [string, string, number] => {
    const [from = '', to = ''] = pair.split('>');
    return [from, to, seconds];
  });
}
